export default __webpack_public_path__ + "static/media/ic_bookmark.954df3c1.svg";